// extracted by mini-css-extract-plugin
export var menuIcon = "_ue-0";
export var menuIconInline = "_ue-1";